import { render, staticRenderFns } from "./deliveryPlatform.vue?vue&type=template&id=680f2b98&scoped=true"
import script from "./deliveryPlatform.vue?vue&type=script&lang=js"
export * from "./deliveryPlatform.vue?vue&type=script&lang=js"
import style0 from "./deliveryPlatform.vue?vue&type=style&index=0&id=680f2b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f2b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680f2b98')) {
      api.createRecord('680f2b98', component.options)
    } else {
      api.reload('680f2b98', component.options)
    }
    module.hot.accept("./deliveryPlatform.vue?vue&type=template&id=680f2b98&scoped=true", function () {
      api.rerender('680f2b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/deliveryPlatform.vue"
export default component.exports